var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _line, _path4, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 3.22852V3.22852C11.4404 3.22852 12 3.78816 12 4.47852V17.2285C12 18.3331 11.1046 19.2285 10 19.2285H4C2.89543 19.2285 2 18.3331 2 17.2285V4.47852C2 3.78816 2.55964 3.22852 3.25 3.22852V3.22852",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.22852H17C18.1046 6.22852 19 7.12395 19 8.22852V14.2285C19 15.3331 18.1046 16.2285 17 16.2285H14",
    stroke: "white",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7.22852,
    width: 6,
    height: 2,
    stroke: "white",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.30078,
    y: 10.5898,
    width: 1.27836,
    height: 1.27836,
    stroke: "white",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.30078,
    y: 13.3418,
    width: 1.27836,
    height: 1.27836,
    stroke: "white",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.30078,
    y: 16.0977,
    width: 1.27836,
    height: 1.27836,
    stroke: "white",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.15234,
    y: 10.5898,
    width: 1.27836,
    height: 1.27836,
    stroke: "white",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.15234,
    y: 13.3418,
    width: 1.27836,
    height: 1.27836,
    stroke: "white",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.15234,
    y: 16.0977,
    width: 1.27836,
    height: 1.27836,
    stroke: "white",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.00391,
    y: 10.5898,
    width: 1.27836,
    height: 1.27836,
    stroke: "white",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.00391,
    y: 13.3418,
    width: 1.27836,
    height: 1.27836,
    stroke: "white",
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.00391,
    y: 16.0977,
    width: 1.27836,
    height: 1.27836,
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75195 1.22852L4.0809 0.851962C3.93321 0.722938 3.72372 0.692172 3.54516 0.773283C3.3666 0.854393 3.25195 1.0324 3.25195 1.22852L3.75195 1.22852ZM4.78796 2.13355L4.45901 2.5101C4.64743 2.6747 4.92849 2.6747 5.11691 2.5101L4.78796 2.13355ZM5.82397 1.22852L6.15292 0.851962C5.9645 0.687367 5.68343 0.687367 5.49502 0.851962L5.82397 1.22852ZM6.85998 2.13355L6.53103 2.5101C6.71944 2.6747 7.00051 2.6747 7.18893 2.5101L6.85998 2.13355ZM7.89598 1.22852L8.22493 0.851962C8.03652 0.687367 7.75545 0.687367 7.56704 0.851962L7.89598 1.22852ZM8.93199 2.13355L8.60304 2.5101C8.79146 2.6747 9.07253 2.6747 9.26094 2.5101L8.93199 2.13355ZM9.968 1.22852H10.468C10.468 1.0324 10.3533 0.854393 10.1748 0.773283C9.99624 0.692172 9.78675 0.722938 9.63905 0.851962L9.968 1.22852ZM9.468 5.77345C9.468 6.04959 9.69186 6.27345 9.968 6.27345C10.2441 6.27345 10.468 6.04959 10.468 5.77345H9.468ZM4.25195 5.77345V1.22852H3.25195V5.77345H4.25195ZM3.423 1.60507L4.45901 2.5101L5.11691 1.75699L4.0809 0.851962L3.423 1.60507ZM5.11691 2.5101L6.15292 1.60507L5.49502 0.851962L4.45901 1.75699L5.11691 2.5101ZM5.49502 1.60507L6.53103 2.5101L7.18893 1.75699L6.15292 0.851962L5.49502 1.60507ZM7.18893 2.5101L8.22493 1.60507L7.56704 0.851962L6.53103 1.75699L7.18893 2.5101ZM7.56704 1.60507L8.60304 2.5101L9.26094 1.75699L8.22493 0.851962L7.56704 1.60507ZM9.26094 2.5101L10.2969 1.60507L9.63905 0.851962L8.60304 1.75699L9.26094 2.5101ZM9.468 1.22852V5.77345H10.468V1.22852H9.468Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.08008,
    y1: 5.94141,
    x2: 10.7591,
    y2: 5.94141,
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6.22852L17 16.2285",
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 12.7285,
    x2: 15.5,
    y2: 14.7285,
    stroke: "white",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 7.72852,
    x2: 15.5,
    y2: 10.7285,
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosFailed);
export default __webpack_public_path__ + "static/media/pos-failed.ff3ea1fe68f14140432cca30c39afe1d.svg";
export { ForwardRef as ReactComponent };